function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.0764 17.4804L21.0755 17.4795C20.6975 17.1015 20.0849 17.1015 19.7069 17.4795L19.0221 18.1652L15.904 15.0472C15.5616 14.7048 15.0978 14.513 14.613 14.513H11.7177C11.2128 14.513 10.8046 14.104 10.8046 13.6V9.94777L12.6307 11.7739L15.3233 11.437C15.8501 11.3712 16.2208 10.8864 16.146 10.3605L16.1451 10.3577C16.0702 9.83181 15.5781 9.46933 15.053 9.55425L13.4159 9.81994L11.1808 7.58571C10.9397 7.34375 10.612 7.20862 10.2705 7.20862H10.265C9.55465 7.20862 8.97852 7.78475 8.97852 8.49602V14.513C8.97852 15.521 9.7957 16.3391 10.8046 16.3391H14.613L18.4542 20.1803C18.8112 20.5364 19.3891 20.5364 19.7452 20.1803L20.3917 19.5348L21.0764 18.8491C21.4544 18.4711 21.4544 17.8584 21.0764 17.4804V17.4804Z",
  stroke: "#00A99D",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.7167 3.55608C11.7167 4.565 10.8995 5.38219 9.89056 5.38219C8.88163 5.38219 8.06445 4.565 8.06445 3.55608C8.06445 2.54716 8.88163 1.72998 9.89056 1.72998C10.8995 1.72998 11.7167 2.54716 11.7167 3.55608V3.55608Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.15221 12.092C5.02571 12.8444 3.5 14.8677 3.5 17.2517C3.5 20.2775 5.95246 22.73 8.97831 22.73C11.5403 22.73 13.686 20.9687 14.285 18.5921",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.0764 17.4804L21.0755 17.4795C20.6975 17.1015 20.0849 17.1015 19.7069 17.4795L19.0221 18.1652L15.904 15.0472C15.5616 14.7048 15.0978 14.513 14.613 14.513H11.7177C11.2128 14.513 10.8046 14.104 10.8046 13.6V9.94777L12.6307 11.7739L15.3233 11.437C15.8501 11.3712 16.2208 10.8864 16.146 10.3605L16.1451 10.3577C16.0702 9.83181 15.5781 9.46933 15.053 9.55425L13.4159 9.81994L11.1808 7.58571C10.9397 7.34375 10.612 7.20862 10.2705 7.20862H10.265C9.55465 7.20862 8.97852 7.78475 8.97852 8.49602V14.513C8.97852 15.521 9.7957 16.3391 10.8046 16.3391H14.613L18.4542 20.1803C18.8112 20.5364 19.3891 20.5364 19.7452 20.1803L20.3917 19.5348L21.0764 18.8491C21.4544 18.4711 21.4544 17.8584 21.0764 17.4804V17.4804Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcoAccessibility(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAccessibility);
export default __webpack_public_path__ + "static/media/ico-accessibility.c86815b3.svg";
export { ForwardRef as ReactComponent };